<template>
  <div>
    <div>
      <p class="contentType">
        <span>Condition Type:</span>
        <span>{{ formName }}</span>
      </p>
    </div>
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item
        label="Covenants compliance check frequency:"
        prop="covenantsComplianceCheckFrequency"
      >
        <el-select
          v-model="form.covenantsComplianceCheckFrequency"
          style="width: 300px"
        >
          <el-option
            v-for="option in covtList"
            :key="option.value"
            :value="option.value"
            :label="option.label"
          />
        </el-select>
        <!-- <el-input
          style="width: 300px"
          onkeyup="value=value.replace(/[^\d]/g,'')"
          v-model="form.covenantsComplianceCheckFrequency"
        ></el-input> -->
      </el-form-item>
    </el-form>
    <common-form ref="commonForm" :defaultData="_commonData"></common-form>
  </div>
</template>

<script>
import CommonForm from './common-form'
export default {
  components: { CommonForm },
  data() {
    const covtList = [
      { value: 1, label: 'annually' },
      { value: 2, label: 'half-yearly' },
      { value: 3, label: 'quarterly' },
    ]
    return {
      formName: 'COVT',
      covtList,
      form: {
        covenantsComplianceCheckFrequency: '',
      },
      commonFormData: {},
      rules: {
        covenantsComplianceCheckFrequency: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    _commonData() {
      return {
        ...this.commonFormData,
      }
    },
  },
  watch: {
    d_value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.commonFormData = newValue
        this.$set(
          this.form,
          'covenantsComplianceCheckFrequency',
          newValue.covenantsComplianceCheckFrequency,
        )
      },
    },
  },
  props: {
    d_value: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormData() {
      return {
        ...this.form,
        formName: this.formName,
        ...this.$refs.commonForm.getCommonForm(),
      }
    },
    async checkValid() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        return await this.$refs.commonForm.checkCommonValid()
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped lang="less">
.contentType {
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
